export function detectAndRedirect() {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  const iosUrl = "https://apps.apple.com/ph/app/papsi-mobile/id1636880216";
  const androidUrl = "https://play.google.com/store/apps/details?id=com.app.papsimobile&pcampaignid=web_share";
  const webFallback = "https://pafcpic.ph/";

  if (/android/i.test(userAgent)) {
    window.location.href = androidUrl;
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    window.location.href = iosUrl;
  } else {
    alert("Please open this link on your mobile device to download the app.");
    window.location.href = webFallback;
  }
}
